var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logs"},_vm._l((_vm.logs),function(log,logindex){return _c('div',{key:("log-" + logindex)},[_c('h2',[_vm._v(_vm._s(log.type))]),_c('pre',{domProps:{"innerHTML":_vm._s(log.content)}})])}))}
var staticRenderFns = []

export { render, staticRenderFns }